/** Query param `directDebitConsent` for company list (Advanced Search). */
export const DIRECT_DEBIT_CONSENT_QUERY = {
  ALL: "",
  ENABLED: "enabled",
  DISABLED: "disabled",
} as const;

export type DirectDebitConsentFilter =
  (typeof DIRECT_DEBIT_CONSENT_QUERY)[keyof typeof DIRECT_DEBIT_CONSENT_QUERY];

export const directDebitConsentDropdownValues = [
  { label: "All", value: DIRECT_DEBIT_CONSENT_QUERY.ALL },
  { label: "Enabled", value: DIRECT_DEBIT_CONSENT_QUERY.ENABLED },
  { label: "Disabled", value: DIRECT_DEBIT_CONSENT_QUERY.DISABLED },
];
